[
  {
    "code": "CY-04",
    "name": "Ammochostos"
  },
  {
    "code": "CY-06",
    "name": "Keryneia"
  },
  {
    "code": "CY-03",
    "name": "Larnaka"
  },
  {
    "code": "CY-01",
    "name": "Lefkosia"
  },
  {
    "code": "CY-02",
    "name": "Lemesos"
  },
  {
    "code": "CY-05",
    "name": "Pafos"
  }
]